import {memo} from 'react';

export interface IMarkeredTextProps {
    marker: string;
    children: string;
}

function MarkeredText({children}: IMarkeredTextProps) {
    return <>{children}</>;
}

export default memo(MarkeredText);
